import {
  FETCH_INTEGRATION_CONFIG,
  FETCH_INTEGRATION_CONFIG_SUCCESS,
  FETCH_INTEGRATION_CONFIG_FAILED,
  EDIT_INTEGRATION_CONFIG
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set } from "firebase/database";

export const fetchIntegrationConfig = () => (dispatch) => {
  const { integrationConfigRef } = firebase;

  dispatch({ type: FETCH_INTEGRATION_CONFIG, payload: null });

  onValue(
    integrationConfigRef,
    (snapshot) => {
      if (snapshot.val()) {
        dispatch({ type: FETCH_INTEGRATION_CONFIG_SUCCESS, payload: snapshot.val() });
      } else {
        dispatch({ type: FETCH_INTEGRATION_CONFIG_FAILED, payload: "not_configured" });
      }
    },
    (error) => {
      // Permission denied (mobile non-admin) or network error
      dispatch({ type: FETCH_INTEGRATION_CONFIG_FAILED, payload: error.message });
    }
  );
};

export const editIntegrationConfig = (data) => (dispatch) => {
  const { integrationConfigRef } = firebase;

  dispatch({ type: EDIT_INTEGRATION_CONFIG, payload: null });
  set(integrationConfigRef, data);
};
